import MorpherWallet from 'morpherwallet-sdk';
import Cookie from 'js-cookie';
import { getWalletClient } from './viem';

const morpherwalletLogout = (morpherwallet: MorpherWallet): Promise<boolean> => {
	return new Promise((resolve, reject) => {
		let resolved = false;
		let timer = setTimeout(() => {
			clearTimeout(timer);
			if (!resolved) {
				resolved = true;
				resolve(false);	
			}
		}, 5000);

		morpherwallet.logout().then(() => {
			clearTimeout(timer);
			resolved = true;
			resolve(true);
		});

	});			
}

const morpherWalletConfig = async function(rpcURL?: string, chainId?: string) {
	if (!rpcURL) {
		rpcURL =import.meta.env.VITE_MORPHER_WALLET_ADDRESS || ''
	}
	if (!chainId) {
		chainId = String(import.meta.env.VITE_MORPHER_WALLET_CHAIN_ID)
	}
	const config = {
		show_transaction: false,
		confirm_transaction: false,
		show_message: false,
		confirm_message: false,
		env: import.meta.env.VITE_MORPHER_WALLET_ENV,
		locale: Cookie.get('locale'),
		rpcURL,
		chainId
	};

	const morpherwallet = new MorpherWallet(
		rpcURL || '',
		Number(chainId),
		config
	);
	const provider = await morpherwallet.getProvider();

	const walletClient = getWalletClient(provider)


	return {
		morpherwallet,
		provider,
		walletClient
	};
};

export { morpherWalletConfig, morpherwalletLogout };
